import { AfterViewInit, ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, forwardRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import intlTelInput from 'intl-tel-input';
import { InputTextModule } from 'primeng/inputtext';
import { UtilsLoaderService } from '../../service/utils-loader.service';
import { BehaviorSubject } from 'rxjs';
import { PhoneValidService } from '../../service/phone-valid.service';
import { PhoneDetails } from '../../interfaces/phone-details';

export const INTLTELINPUT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => IntlTelInputComponent),
  multi: true
};

export const INTLTELINPUT_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => IntlTelInputComponent),
  multi: true,
};

@Component({
  selector: 'app-intl-tel-input',
  standalone: true,
  imports: [InputTextModule],
  providers: [INTLTELINPUT_VALUE_ACCESSOR],
  templateUrl: './intl-tel-input.component.html',
  styleUrl: './intl-tel-input.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class IntlTelInputComponent implements OnInit, ControlValueAccessor, AfterViewInit, Validator {
  @Input() inputId: string | undefined;
  @Input() invalid: boolean;
  @Input() readonly: boolean;
  @Input() required: boolean;
  @Input() placeholderText: string;
  @Input() disabled: boolean;
  @Input() inputClass: string;
  @Input() containerClass: string;
  private onChange = (_: any) => { };
  private onTouched: any = () => { };
  private _onPhoneValid!: BehaviorSubject<PhoneDetails>;

  @ViewChild('telefono', { static: true }) phoneInput: any;
  iti: any;
  public value: PhoneDetails;
  public isPhoneValid: boolean = true;
  public errorMessage: string = '';
  //public phoneNumber: string;
  //private countryCode: string;
  constructor(
    private utilsLoader: UtilsLoaderService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private phneValid: PhoneValidService
  ) {
    this.invalid = false;
    this.disabled = false;
    this.readonly = false;
    this.required = false;
    this.placeholderText = '';
    this.inputClass = '';
    this.containerClass = 'w-full';
    this.value = {
      phoneNumber: '',
      countryCode: 'BO',
      dialCode: '591'
    };
  }

  async ngOnInit() {
    await this.utilsLoader.loadUtils();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.phoneInput) {
        this.iti = intlTelInput(this.phoneInput.nativeElement, {
          allowDropdown: true,
          //autoPlaceholder: '',
          customContainer: this.containerClass,
          countryOrder: ['BO', 'US', 'BR'],
          countrySearch: false,
          // loadUtils: () => import("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"),
          // geoIpLookup: (callback: any) => {
          //   fetch('https://ipinfo.io/json?token=1b08f2f1fd8afb') // Replace with a valid token
          //     .then((resp) => resp.json())
          //     .then((resp) => callback(resp.country))
          //     .catch(() => callback('bo'));
          // },
          //dropdownContainer: null,
          //excludeCountries: [],
          //fixDropdownWidth: true,
          //formatAsYouType: true,
          //formatOnDisplay: true,
          initialCountry: 'BO',
          nationalMode: false,
          utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
          //onlyCountries: [],
          placeholderNumberType: 'MOBILE',
          showFlags: true,
          separateDialCode: true,
          //strictMode: true,
          useFullscreenPopup: false,
          // validationNumberType: 'PERSONAL_NUMBER'

        } as any);
        console.log('Initialized ITI:', this.iti);
        this.phoneInput.nativeElement.addEventListener('countrychange', () => {
          this.value.countryCode = this.iti.getSelectedCountryData().iso2;
          this.value.dialCode = this.getDialCode();
          this.updateValue();
          console.log('changing country code: ', JSON.stringify(this.value));
        });
      }
    }, 500);

  }

  editCustomContainer(value: string) {
    if (this.iti) {
      const customContainerElement = this.phoneInput.nativeElement.closest(`.${this.containerClass}`);
      if (customContainerElement) {
        customContainerElement.classList.remove(this.containerClass); // Remove the old class
        customContainerElement.classList.add(value); // Add the new class
        console.log(`Updated custom container class to: ${value}`);
      } else {
        console.error('Custom container element not found.');
      }
      this.containerClass = value;
      // this.iti.destroy();
      // this.iti = intlTelInput(this.phoneInput.nativeElement, {
      //   allowDropdown: true,
      //   //autoPlaceholder: '',
      //   customContainer: value,
      //   countryOrder: ['BO', 'US', 'BR'],
      //   countrySearch: false,
      //   // loadUtils: () => import("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js"),
      //   // geoIpLookup: (callback: any) => {
      //   //   fetch('https://ipinfo.io/json?token=1b08f2f1fd8afb') // Replace with a valid token
      //   //     .then((resp) => resp.json())
      //   //     .then((resp) => callback(resp.country))
      //   //     .catch(() => callback('bo'));
      //   // },
      //   //dropdownContainer: null,
      //   //excludeCountries: [],
      //   //fixDropdownWidth: true,
      //   //formatAsYouType: true,
      //   //formatOnDisplay: true,
      //   initialCountry: 'BO',
      //   nationalMode: false,
      //   utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
      //   //onlyCountries: [],
      //   placeholderNumberType: 'FIXED_LINE',
      //   showFlags: true,
      //   separateDialCode: true,
      //   //strictMode: true,
      //   useFullscreenPopup: false,
      //   // validationNumberType: 'PERSONAL_NUMBER'

      // } as any);
    }
  }

  addClass(className: string) {
    const element = this.phoneInput.nativeElement;
    this.renderer.addClass(element, className);
  }

  removeClass(className: string) {
    const element = this.phoneInput.nativeElement;
    this.renderer.removeClass(element, className);
  }

  getDialCode(): string {
    if (this.iti) {
      const countryData = this.iti.getSelectedCountryData();
      console.log('Selected Country Data:', countryData);
      return countryData.dialCode;
    } else {
      console.error('intl-tel-input is not initialized.');
      return '';
    }
  }

  validatePhoneNumber(): void {
    const rawNumber = this.phoneInput.nativeElement.value;
    if (!rawNumber) {
      console.log('Raw Input Value:', rawNumber);
      this.errorMessage = 'Por favor ingrese un número telefónico.';
      this.isPhoneValid = false;
      console.log('is phone valid:', this.isPhoneValid);
      this.cdr.markForCheck();
      return;
    }
    this.value.phoneNumber = rawNumber;
    console.log('value of value: ', JSON.stringify(this.value));
    if (this.iti) {
      const isValid = this.iti.isValidNumber();
      this.isPhoneValid = isValid;
      this.cdr.markForCheck();
      console.log('isPhoneValid: ', JSON.stringify(this.isPhoneValid));

      if (!this.isPhoneValid) {
        this.errorMessage = 'Por favor ingrese un número telefónico válido.';
      } else {
        this.errorMessage = '';
        this.phneValid.updatePhoneDetails(this.value);
        console.log('Valid phone number:', this.iti.getNumber());
      }
    } else {
      console.error('intl-tel-input is not initialized.');
      this.errorMessage = 'An unexpected error occurred.';
      this.isPhoneValid = false;
      this.cdr.markForCheck();
    }
  }

  writeValue(value: any): void {
    if (value) {
      this.value = value;
      if (this.iti) {
        this.iti.setNumber(this.value.phoneNumber);
        this.iti.setCountry(this.value.countryCode);
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(event: any): void {
    if (event && event.isTrusted && event.target && event.target.value) {
      this.value.phoneNumber = event.target.value;
      this.validatePhoneNumber();
      this.updateValue();
    }
  }


  updateValue(): void {
    // console.log('value on update value: ', JSON.stringify(this.value));
    this.onChange(this.value);
    // console.log('phone number on lib: ' + this.iti.getNumber());
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (!this.isPhoneValid) {
      return { invalidPhoneNumber: { valid: false, value: control.value } };
    }
    return null; // No errors
  }

}